import {Pipe, PipeTransform} from '@angular/core';
import {bodyToKeyValue} from '../../../../_reducers/bodyToKeyValue.fn';
import {KeyValue} from '@angular/common';

@Pipe({name: 'FilterWarningsWithOtherRequired'})
export class FilterWarningsWithOther implements PipeTransform {
	constructor() {}
	transform(input: any[]): KeyValue<any, any>[] {
		const field = input
			.map(({key, value}) => key === 'field' ? value : null)
			.filter(Boolean);
		const templateField = input
			.map(({key, value}) => key === 'templateField' ? value : null)
			.filter(Boolean);

		if (field[0].content.lastEntry.selected && !templateField[0].body.otherRequired) {
			return Object.entries(field[0].content.lastEntry).map(([key, value]) => {
				return {key, value};
			});
		}

		return templateField[0].body.otherRequired ? bodyToKeyValue(templateField[0].body) : bodyToKeyValue(field[0].content.lastEntry);
	}
}
